import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';

export default function StockExceededDialog({open, setOpen, value, setValue}) {
  return (
    <React.Fragment>
      <Button variant="outlined" onClick={() => setOpen(true)}>
        Open alert dialog
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        role="alertdialog"
      >
        <DialogTitle id="alert-dialog-title">
          {"Beschikbare stock overschreden!"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Met deze verkoop wordt de beschikbare stock overschreden.<br/>
            <Typography color="#F00">De verkooplijn zal worden verwijderd.</Typography> <br/>
            <b>Maximaal beschikbaar is: {value}</b>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
